import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  public open = false;

  constructor(private router: Router) {}

  public get isHome() {
    return this.router.url === '/';
  }

  ngOnInit(): void {}
}
